
	import mixins from "vue-typed-mixins";

	import Session from "@/shared/mixins/Session";
	const MIXINS = [Session];
	const Vue = mixins(...MIXINS);

	export default Vue.extend({
		name: "App",
		mixins: MIXINS,
		created() {
      this.restore();
			this.isReady = true;
		},
		data() {
			return {
				isReady: false as boolean,
			};
		},
		methods: {},
	});
